export default __webpack_public_path__ + "static/media/logo.12bd8df2.png";